/* ================================================== */
/* FUNCTIONS
/* ================================================== */


/* ================================================== */
/* DOCUMENT READY
/* ================================================== */

$(document).ready(function(){


});



/* ================================================== */
/* WINDOW RESIZE & ORIENTATIONCHANGE
/* ================================================== */

$(window).on('resize orientationchange', function(){
  if ($(window).width() < 767) {
    $('body').addClass('mobile tablet');
  } else {
    $('body').removeClass('mobile tablet');
  	$('body').removeClass('mainMenu--open subMenu--open');
  }
});